export const buttons = [
  { value: 'EXTRACTED_METADATA', label: 'Extracted Document Metadata' },
  { value: 'AUTOMATED_TEST', label: 'Snappt Automated Test' },
  { value: 'TEXT_INSERTION', label: 'Text Insertion' }
];
